import { Formik } from "formik";
import { useDispatch } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
    Button,
    CardTitle,
    Form,
    Input,
    Label,
    InputGroup,
    InputGroupText,
} from "reactstrap";
import * as Yup from "yup";
import { useEffect, useState } from "react";
import "./login.scss";
import { LoginAPI, RegisterAPI } from "../redux/auth/slice";
import { toast } from "react-toastify";
import { FULL_LOGO_2 } from "../assets";
import axios from "axios";
import { decryptResponse, encryptRequest } from "../helpers/encryption";
import { decryptRequestSignup, encryptResponseSignup } from "../helpers/encryptionSignup";

const Signup = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [ipAddress, setIpAddress] = useState('');
    const { id } = useParams();


    useEffect(() => {

        if (id) {
            const res = decryptRequestSignup(id)
            console.log("----res----", res);
            setIpAddress(res?.mac)
        }
    }, [id])

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <div>
            <div className="topbar_container">
                <div className="topbar_inner">
                    <div className="wordmark_wordmark">
                        <img src={FULL_LOGO_2} width={200} />
                    </div>
                    <div className="topbar-menu_menu">
                        <div aria-haspopup="menu" tabindex="0" aria-expanded="false" id="«R55jddbH1»" className="topbar-menu_button" onClick={() => navigate("/")}>Home</div>
                        <div aria-haspopup="menu" tabindex="0" aria-expanded="false" id="«R95jddbH1»" className="topbar-menu_button" onClick={() => navigate("/resources")}>Resources</div>
                    </div>
                    <div className="topbar_rightSection"><a className="menu-button_button" onClick={() => navigate("/login")}>Login</a>
                        {/* <a className="menu-button_button menu-button_primary" onClick={() => navigate("/signup")}>Sign up</a> */}
                    </div>

                </div>
            </div>
            <div className="auth-wrapper auth-basic">
                <div className="auth-inner my-2">
                    <div className="box-rectangle-bottom" style={{ padding: "14px" }}>
                        <div className="corner-border top-left"></div>
                        <div className="corner-border top-right"></div>
                        <div className="corner-border bottom-left"></div>
                        <div className="corner-border bottom-right"></div>
                        <div className="main-data">
                            <Link
                                className="brand-logo align-items-center d-flex justify-content-center mt-1 mb-4"
                                to="/"
                                onClick={(e) => e.preventDefault()}
                            >
                                {/* Uncomment and use your logo here */}
                                {/* {skin === "dark" ? <img src={DuraPowerLogo} style={{ height: "80px" }} /> : <img src={DuraPowerLogoLight} style={{ height: "80px" }} />} */}
                            </Link>
                            <CardTitle tag="h4" className="mb-1 text-center text-white">
                                Welcome to DEVGLU.AI!
                            </CardTitle>
                            <Formik
                                initialValues={{
                                    name: "",
                                    email: "",
                                    password: "",
                                }}
                                validationSchema={Yup.object().shape({
                                    name: Yup.string()
                                        .required("Name is required"),
                                    email: Yup.string()
                                        .email("Invalid email address")
                                        .required("Email is required"),
                                    password: Yup.string()
                                        .min(6, "Password must be at least 6 characters")
                                        .required("Password is required"),
                                })}
                                onSubmit={(values, { resetForm }) => {
                                    // Replace with your actual login API call
                                    let payload = values;
                                    payload.macAddress = ipAddress;
                                    dispatch(
                                        RegisterAPI(payload)
                                    ).then((res) => {
                                        if (res?.token) {
                                            toast.success('User Created!');
                                            resetForm();
                                            navigate("/login");
                                        }
                                        console.log("---res----", res);

                                    });
                                    console.log("Form submitted:", payload);
                                }}
                            >
                                {({ values, errors, touched, handleChange, handleSubmit }) => (
                                    <Form className="mt-2" onSubmit={handleSubmit}>
                                        <div className="mb-1 auth-login-form text-white">
                                            <Label className="form-label text-white" for="email">
                                                Name
                                            </Label>
                                            <div className="d-flex border border-2 rounded-3 p-1">
                                                <div className="bg-mail my-auto me-1"></div>
                                                <Input
                                                    style={{ backgroundColor: "#00000000", color: "#ffffff" }}
                                                    name="name"
                                                    type="text"
                                                    value={values.name}
                                                    id="name"
                                                    onChange={handleChange}
                                                    placeholder="Name"
                                                    autoFocus
                                                />
                                            </div>
                                            {errors.name && touched.name ? (
                                                <p className="text-danger mb-0 error-form">{errors.name}</p>
                                            ) : null}
                                        </div>
                                        <div className="mb-1 auth-login-form text-white">
                                            <Label className="form-label text-white" for="email">
                                                Email
                                            </Label>
                                            <div className="d-flex border border-2 rounded-3 p-1">
                                                <div className="bg-mail my-auto me-1"></div>
                                                <Input
                                                    style={{ backgroundColor: "#00000000", color: "#ffffff" }}
                                                    name="email"
                                                    type="email"
                                                    value={values.email}
                                                    id="email"
                                                    onChange={handleChange}
                                                    placeholder="Email"
                                                    autoFocus
                                                />
                                            </div>
                                            {errors.email && touched.email ? (
                                                <p className="text-danger mb-0 error-form">{errors.email}</p>
                                            ) : null}
                                        </div>
                                        <div className="mb-1 auth-login-password">
                                            <div className="d-flex justify-content-between">
                                                <Label className="form-label text-white" for="password">
                                                    Password
                                                </Label>
                                            </div>
                                            <div className="d-flex border border-2 rounded-3 p-1">
                                                <div className="bg-lock my-auto me-1"></div>
                                                <InputGroup className="input-group-merge">
                                                    <Input
                                                        style={{ backgroundColor: "#00000000", color: "#ffffff" }}
                                                        name="password"
                                                        type={showPassword ? "text" : "password"}
                                                        value={values.password}
                                                        id="password"
                                                        onChange={handleChange}
                                                        placeholder="Password"
                                                    />
                                                    <InputGroupText
                                                        style={{ cursor: "pointer", backgroundColor: "#00000000" }}
                                                        onClick={togglePasswordVisibility}
                                                    >
                                                        {showPassword ? (
                                                            <i className="bi bi-eye-slash"></i>
                                                        ) : (
                                                            <i className="bi bi-eye"></i>
                                                        )}
                                                    </InputGroupText>
                                                </InputGroup>
                                            </div>
                                            <div className="d-flex justify-content-between align-items-center">
                                                {errors.password && touched.password ? (
                                                    <p className="text-danger mb-0 error-form">{errors.password}</p>
                                                ) : null}
                                                <Link to="/forgot-password" className="ms-auto error-form mt-1">
                                                    Forgot Password?
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="position-relative mt-3">
                                            <Button
                                                color="primary"
                                                type="submit"
                                                block
                                                className="rounded-3"
                                            >
                                                Signup
                                            </Button>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Signup;